import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { EstablishmentModel } from 'src/app/core/models/establishment.model';
import { EstablishmentService } from '../../establishment.service';
import { FormModalBaseComponent } from 'src/app/core/base/components/form-modal-base/form-modal-base.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Observable as RxObservable, of } from 'rxjs';
import { map as rxMap } from 'rxjs/operators';
import { UserProfileService } from '../../../user-profile/user-profile.service';
import { UserProfileModel } from '../../../../../../core/models/user-profile.model';
import { AddressService } from '../../../../../../core/services/address.service';
import { AddressModel } from '../../../../../../core/models/address.model';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';
import { AuthService } from '../../../../../../core/services/auth.service';
import { Router } from '@angular/router';
import {
  EstablishmentTypeEnum,
  EstablishmentTypeEnumFrench,
  establishmentTypeFrenchToEnum,
  establishmentTypeFrenchTranslation,
} from '../../../../../../core/enums/establishment-type.enum';
import { ResponseTypeEnum } from '../../../../../../core/base/enum/response-type.enum';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { b64ToBlob } from '../../../../../../core/helpers/b64ToBlob.helper';
import { ContentTypeEnum } from '../../../../../../core/base/enum/content-type.enum';
import { FileSaverService } from 'ngx-filesaver';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatStepper } from '@angular/material/stepper';
import { FileInput } from 'ngx-material-file-input';
import { GenericImportsSettingsService } from '../../../../settings/generic-imports/generic-imports.service';
import { AccountChartModel } from '../../../../../../core/models/account-chart.model';
import { AccountChartService } from '../../../../settings/account-chart/account-chart.service';

@Component({
  selector: 'vex-establishment-create-update',
  templateUrl: './establishment-create-update-delete.component.html',
  styleUrls: ['./establishment-create-update-delete.component.scss'],
})
export class EstablishmentCreateUpdateDeleteComponent
  extends FormModalBaseComponent<EstablishmentModel>
  implements OnInit
{
  formEstablishmentType: UntypedFormGroup;
  infoStepGroup: UntypedFormGroup;
  billingStepGroup: UntypedFormGroup;
  paymentStepGroup: UntypedFormGroup;
  establishmentType = EstablishmentTypeEnumFrench;
  establishmentTypeFrenchTranslation = establishmentTypeFrenchTranslation;
  establishmentTypeEnum = EstablishmentTypeEnum;
  establishmentTypeSelected: EstablishmentTypeEnum = establishmentTypeFrenchToEnum(this.establishmentType[0]);
  phoneForm = new UntypedFormGroup({});
  userProfiles$: Observable<UserProfileModel[]>;
  accountCharts$: Observable<AccountChartModel[]>;
  addresses$: Observable<AddressModel[]>;
  establishments$: Observable<EstablishmentModel[]>;
  linkedToMain = new UntypedFormControl(false);
  billingModeControl = new UntypedFormControl('address');
  statusTva = ['Soumis', 'Non soumis'];
  canDownloadModelPermissions = false;
  establishmentTypeFromImportModal: EstablishmentTypeEnum;

  // Table de sélection des adresses de facturation
  addressesDataSource = new MatTableDataSource<AddressModel>();
  addressColumns: Array<FeiColumn> = [
    { label: 'Libellé', column: 'label', propertyDisplay: 'label', canSort: true },
    { label: 'Rue', column: 'street', propertyDisplay: 'street', canSort: true },
    { label: 'Complément', column: 'additionalAddress', propertyDisplay: 'additionalAddress', canSort: true },
    { label: 'Code postal', column: 'postalCode', propertyDisplay: 'postalCode', canSort: true },
    { label: 'Ville', column: 'city', propertyDisplay: 'city', canSort: true },
    // buildingsInfo est un tableau: affichage via colonne custom
    { label: 'Bâtiments liés', column: 'buildingsInfo', type: 'custom', canSort: false },
  ];
  addressDisplayedColumns = this.addressColumns.map(c => c.column);
  addressCount = 0;
  addressPageSize = 10;
  addressPageIndex = 1;
  addressSortField = 'createdAt';
  addressSortOrder: 'asc' | 'desc' | '' = 'desc';
  addressSearch = '';
  accountingSoftwareId = '';

  @ViewChild('stepper') stepper: MatStepper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<EstablishmentModel>>,
    public service: EstablishmentService,
    private userProfileService: UserProfileService,
    private accountChartService: AccountChartService,
    private addressService: AddressService,
    public authService: AuthService,
    private router: Router,
    private fileSaver: FileSaverService,
    private snackbar: SnackbarService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit() {
    super.ngOnInit();
    this.customerReferentAutocompleteChange();
    this.accountChartAutocompleteChange();
    this.addressAutocompleteChange();
    this.initForm();
    this.initStepGroups();
    this.establishmentTypeFromImportModal = this.data?.establishmentTypeFromImportModal;
    this.authService.getCurrentUserPermissions$().subscribe(permissions => {
      this.canDownloadModelPermissions = permissions.includes(ENUM_PERMISSIONS.READ_ESTABLISHMENT);
    });

    this.form.get('establishmentType')?.valueChanges.subscribe(type => {
      this.updateValidatorsByEstablishmentType(type);
      const isFrench = this.form.get('isFrenchCompany')?.value;
      this.toggleCompanyFields(isFrench);
    });

    const type =
      this.form.get('establishmentType')?.value || establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE);
    this.updateValidatorsByEstablishmentType(type);

    this.form.get('mainEstablishment')?.valueChanges.subscribe((est: any) => {
      if (this.form.get('linkedToMain')?.value) {
        const sirenControl = this.form.get('sirenNumber');
        const siretControl = this.form.get('siretNumber');
        const tvaControl = this.form.get('tva');
        const apeControl = this.form.get('ape');
        const vatStatusControl = this.form.get('vatStatus');

        // Always reset previous values when establishment changes
        sirenControl?.reset();
        siretControl?.reset();
        tvaControl?.reset();
        apeControl?.reset();
        vatStatusControl?.reset();

        if (est) {
          if (est.sirenNumber || est.siretNumber || est.tva || est.ape || est.vatStatus !== undefined) {
            if (est.sirenNumber) {
              sirenControl?.setValue(est.sirenNumber);
            }
            if (est.siretNumber) {
              siretControl?.setValue(est.siretNumber);
            }
            if (est.tva) {
              tvaControl?.setValue(est.tva);
            }
            if (est.ape) {
              apeControl?.setValue(est.ape);
            }
            if (est.vatStatus !== undefined) {
              const vatStatusValue = est.vatStatus ? this.statusTva[0] : this.statusTva[1];
              vatStatusControl?.setValue(vatStatusValue);
            }
          } else if (est._id) {
            this.loadMainEstablishment(est._id);
          }
        }
      }
    });

    // Auto-complétion du Siren basé sur le Siret
    this.form.get('siretNumber')?.valueChanges.subscribe((siret: string | null) => {
      const sirenControl = this.form.get('sirenNumber');

      if (siret && !this.form.get('linkedToMain')?.value) {
        // Le Siren correspond aux 9 premiers chiffres du Siret
        const siretStr = siret.toString();
        const siren = siretStr.substring(0, 9);
        sirenControl?.setValue(siren);
      } else if (!siret && !this.form.get('linkedToMain')?.value) {
        sirenControl?.reset();
      }
    });

    this.form.get('linkedToMain')?.valueChanges.subscribe((linked: boolean) => {
      const sirenControl = this.form.get('sirenNumber');
      const siretControl = this.form.get('siretNumber');
      const tvaControl = this.form.get('tva');
      const apeControl = this.form.get('ape');
      const vatStatusControl = this.form.get('vatStatus');
      const dunsControl = this.form.get('dunsNumber');
      const mainEstablishmentControl = this.form.get('mainEstablishment');
      if (linked) {
        this.establishmentAutocompleteChange('');
        const est: any = mainEstablishmentControl?.value;
        if (est) {
          if (est.sirenNumber && est.siretNumber && est.tva) {
            siretControl?.setValue(est.siretNumber);
            sirenControl?.setValue(est.sirenNumber);
            tvaControl?.setValue(est.tva);
            if (est.ape) {
              apeControl?.setValue(est.ape);
            }
            if (est.vatStatus !== undefined) {
              const vatStatusValue = est.vatStatus ? this.statusTva[0] : this.statusTva[1];
              vatStatusControl?.setValue(vatStatusValue);
            }
          } else if (est._id) {
            this.loadMainEstablishment(est._id);
          }
        }
        siretControl?.disable();
        siretControl?.clearValidators(); // Enlever l'obligation quand lié à un main
        siretControl?.updateValueAndValidity();
        tvaControl?.disable();
        apeControl?.disable();
        vatStatusControl?.disable();

        // Forcer entreprise française si lié à un établissement principal
        this.form.get('isFrenchCompany')?.setValue(true);
        this.form.get('isFrenchCompany')?.disable();
      } else {
        // Réactiver les champs selon le type d'entreprise
        tvaControl?.enable();
        apeControl?.enable();
        vatStatusControl?.enable();
        this.form.get('isFrenchCompany')?.enable();

        sirenControl?.reset();
        siretControl?.reset();
        tvaControl?.reset();
        apeControl?.reset();
        vatStatusControl?.reset();
        mainEstablishmentControl?.reset();

        // Réappliquer la logique du type d'entreprise
        const isFrenchCompany = this.form.get('isFrenchCompany')?.value;
        this.toggleCompanyFields(isFrenchCompany);
      }
    });

    // Apply initial state based on defaults
    if (this.form.get('linkedToMain')?.value) {
      this.establishmentAutocompleteChange('');
      const est: any = this.form.get('mainEstablishment')?.value;
      if (est) {
        if (est.sirenNumber && est.siretNumber) {
          this.form.get('siretNumber')?.setValue(est.siretNumber);
          this.form.get('sirenNumber')?.setValue(est.sirenNumber);
          this.form.get('tva')?.setValue(est.tva);
          if (est.ape) {
            this.form.get('ape')?.setValue(est.ape);
          }
          if (est.vatStatus !== undefined) {
            const vatStatusValue = est.vatStatus ? this.statusTva[0] : this.statusTva[1];
            this.form.get('vatStatus')?.setValue(vatStatusValue);
          }
        } else if (est._id) {
          this.loadMainEstablishment(est._id);
        }
      }
      this.form.get('siretNumber')?.disable();
      this.form.get('tva')?.disable();
      this.form.get('ape')?.disable();
      this.form.get('vatStatus')?.disable();

      // Forcer entreprise française et désactiver la checkbox si lié à un établissement principal
      this.form.get('isFrenchCompany')?.setValue(true);
      this.form.get('isFrenchCompany')?.disable();

      // Note: dunsNumber n'est pas désactivé car il peut être utilisé pour les entreprises non françaises
    }

    // Auto-calculer le Siren initial si un Siret existe déjà
    if (this.defaults?.siretNumber && this.defaults.siretNumber.length >= 9) {
      const siren = this.defaults.siretNumber.substring(0, 9);
      this.form.get('sirenNumber')?.setValue(siren);
    }

    // Logique simple basée sur la checkbox entreprise française
    this.setupCompanyTypeLogic();

    // Auto-renseigner le SIREN à partir du SIRET (création et édition, PRED-3187)
    const siretCtrl = this.form.get('siretNumber');
    if (siretCtrl) {
      // Async validator: unicité du SIRET (ignorée en édition si le SIRET est inchangé,
      // sinon checkSiretExists trouverait l'établissement lui-même)
      const originalSiret = (this.defaults?.siretNumber || '').toString().replace(/\D/g, '');
      siretCtrl.setAsyncValidators([
        (control: AbstractControl): RxObservable<ValidationErrors | null> => {
          const val = (control.value || '').toString().replace(/\D/g, '');
          if (!val || val.length !== 14) {
            return of(null);
          }
          if (this.defaults?._id && val === originalSiret) {
            return of(null);
          }
          return this.service
            .checkSiretExists(val)
            .pipe(rxMap(r => (r.exists ? { messages: ['Le N° Siret existe déjà.'] } : null)));
        },
      ]);

      siretCtrl.valueChanges.subscribe((val: string) => {
        const clean = (val || '').toString().replace(/\D/g, '');
        if (clean?.length >= 9) {
          this.form.get('sirenNumber')?.setValue(clean.substring(0, 9));
        } else {
          this.form.get('sirenNumber')?.reset();
        }
        // Ne pas déclencher le validateur asynchrone à chaque frappe
        siretCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
    }

    // Chargement initial des adresses pour la table de sélection
    this.loadAddresses();
    this.updateValidatorsByEstablishmentType(type);

    // Mettre à jour la validité des groupes d'étape à chaque changement de formulaire
    this.form.valueChanges.subscribe(() => {
      this.infoStepGroup?.updateValueAndValidity();
      this.billingStepGroup?.updateValueAndValidity();
      this.paymentStepGroup?.updateValueAndValidity();
    });

    // Le step Informations dépend aussi du STATUT du contrôle SIRET (validator async d'unicité) :
    // le statut peut changer sans changement de valeur (PENDING → VALID/INVALID), il faut revalider
    this.form.get('siretNumber')?.statusChanges.subscribe(() => {
      this.infoStepGroup?.updateValueAndValidity();
    });

    // Revalider l'étape facturation quand le mode de facturation change
    this.billingModeControl.valueChanges.subscribe(() => {
      // Réinitialiser les champs de l'autre mode
      if (this.billingModeControl.value === 'email') {
        this.form.get('billingAddress')?.reset();
      } else {
        this.form.get('billingEmail')?.reset();
      }
      this.billingStepGroup?.updateValueAndValidity();
    });

    // Forcer la mise à jour initiale de la validité
    this.infoStepGroup?.updateValueAndValidity();

    // importForm already initialized in base when Import mode
  }

  // Gérer proprement les erreurs de formulaire sans laisser le spinner actif
  override onFormInvalid(): void {
    this.loading = false;
    this.form.markAllAsTouched();

    if (!this.infoStepGroup?.valid) {
      if (this.stepper && this.stepper.selectedIndex !== 0) {
        this.stepper.selectedIndex = 0;
      }
    } else if (!this.billingStepGroup?.valid) {
      if (this.stepper && this.stepper.selectedIndex !== 1) {
        this.stepper.selectedIndex = 1;
      }
    } else if (!this.paymentStepGroup?.valid) {
      if (this.stepper && this.stepper.selectedIndex !== 2) {
        this.stepper.selectedIndex = 2;
      }
    }

    setTimeout(() => (this.loading = false), 0);
  }

  initStepGroups() {
    // Groupes "virtuels" utilisés uniquement pour la validation du stepper
    // Sans ré-attacher les contrôles (pour ne pas casser les bindings du template)
    this.infoStepGroup = new UntypedFormGroup({}, this.infoStepValidator.bind(this));
    this.billingStepGroup = new UntypedFormGroup({}, this.billingStepValidator.bind(this));
    this.paymentStepGroup = new UntypedFormGroup({}, this.paymentStepValidator.bind(this));
  }

  private infoStepValidator(_: AbstractControl): ValidationErrors | null {
    if (!this.form) {
      return { invalid: true };
    }

    // Vérifier les champs requis de l'étape "Informations"
    const requiredFieldsErrors: string[] = [];

    // Champs toujours requis
    const label = this.form.get('label')?.value;
    const establishmentType = this.form.get('establishmentType')?.value;

    if (!label?.trim()) {
      requiredFieldsErrors.push('label');
    }

    if (!establishmentType) {
      requiredFieldsErrors.push('establishmentType');
    }

    // Vérifier selon le type d'entreprise et d'établissement
    const isFrenchCompany = this.form.get('isFrenchCompany')?.value;
    const linkedToMain = this.form.get('linkedToMain')?.value;
    const currentType = this.form.get('establishmentType')?.value;
    const isCare = currentType === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE);
    const isSupport = currentType === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.SUPPORT_FUNCTION);

    if (isFrenchCompany) {
      // Entreprise française : vérifier SIRET/SIREN (sauf si lié à un établissement principal ET type SUPPORT)
      if (!linkedToMain || !isSupport) {
        const siretControl = this.form.get('siretNumber');
        const siretNumber = siretControl?.value;
        const sirenNumber = this.form.get('sirenNumber')?.value;

        if (!siretNumber) {
          requiredFieldsErrors.push('siretNumber');
        }

        if (!sirenNumber) {
          requiredFieldsErrors.push('sirenNumber');
        }

        // Bloquer le step tant que le contrôle SIRET est en erreur (pattern, unicité async)
        // ou en cours de validation async — sinon la soumission passe malgré l'erreur affichée
        if (siretControl && !siretControl.disabled && (siretControl.invalid || siretControl.pending)) {
          requiredFieldsErrors.push('siretNumber');
        }
      }

      // Si lié à un établissement principal (uniquement SUPPORT), vérifier que l'établissement principal est sélectionné
      if (linkedToMain && isSupport) {
        const mainEstablishment = this.form.get('mainEstablishment')?.value;
        if (!mainEstablishment) {
          requiredFieldsErrors.push('mainEstablishment');
        }
      }

      // Pour établissements de type CARE français : vérifier les champs fiscaux (hors TVA, non obligatoire)
      if (isCare) {
        const ape = this.form.get('ape')?.value;
        const vatStatus = this.form.get('vatStatus')?.value;

        if (!ape?.trim()) {
          requiredFieldsErrors.push('ape');
        }

        if (!vatStatus) {
          requiredFieldsErrors.push('vatStatus');
        }
      }
    } else {
      // Entreprise étrangère : vérifier DUNS
      const dunsNumber = this.form.get('dunsNumber')?.value;
      if (!dunsNumber?.trim()) {
        requiredFieldsErrors.push('dunsNumber');
      }
    }

    // Comptable rattaché obligatoire pour CARE et SUPPORT_FUNCTION (français OU étranger)
    if (isCare || isSupport) {
      const attachedAccountant = this.form.get('attachedAccountant')?.value;
      if (!attachedAccountant) {
        requiredFieldsErrors.push('attachedAccountant');
      }
    }

    // Vérifier les validateurs asynchrones (ex: unicité SIRET)
    if (this.form.status === 'PENDING') {
      return { invalid: true };
    }

    // Si des champs requis sont manquants, bloquer la navigation
    if (requiredFieldsErrors.length > 0) {
      return { invalid: true, requiredFields: requiredFieldsErrors };
    }

    return null;
  }

  private billingStepValidator(_: AbstractControl): ValidationErrors | null {
    if (!this.form || !this.billingModeControl) {
      return null;
    }

    // L'adresse de facturation n'est plus requise : on autorise une étape vide.
    // Seul le format email est validé s'il est effectivement renseigné.
    if (this.billingModeControl.value === 'email') {
      const billingEmailControl = this.form.get('billingEmail');
      if (billingEmailControl?.value?.trim() && billingEmailControl?.invalid) {
        return { invalid: true, reason: 'billingEmailInvalid' };
      }
    }

    return null;
  }

  private paymentStepValidator(_: AbstractControl): ValidationErrors | null {
    if (!this.form) {
      return null;
    }

    // Déléguer la validation BIC/IBAN au composant standalone (qui pose Validators.required
    // uniquement quand le mode de règlement sélectionné a requiresBankDetails=true)
    const ibanControl = this.form.get('paymentMethodIban');
    const bicControl = this.form.get('paymentMethodBic');
    if (ibanControl?.invalid || bicControl?.invalid) {
      return { invalid: true, reason: 'bankDetailsRequired' };
    }

    return null;
  }

  setupCompanyTypeLogic() {
    // Initialiser l'état basé sur les données existantes
    const hasSiret = !!this.defaults?.siretNumber;
    const hasDuns = !!this.defaults?.dunsNumber;

    // Par défaut, entreprise française (SIRET) sauf si on a déjà un DUNS
    const isFrenchCompany = hasSiret || !hasDuns;
    this.form.get('isFrenchCompany')?.setValue(isFrenchCompany);

    // Appliquer l'état initial
    this.toggleCompanyFields(isFrenchCompany);

    // Réappliquer les validateurs selon le type d'établissement et le type d'entreprise
    const currentType = this.form.get('establishmentType')?.value;
    if (currentType) {
      this.updateValidatorsByEstablishmentType(currentType);
    }

    // Écouter les changements de la checkbox
    this.form.get('isFrenchCompany')?.valueChanges.subscribe((isFrench: boolean) => {
      this.toggleCompanyFields(isFrench);
      // Réappliquer les validateurs selon le type d'établissement et le type d'entreprise
      const currentType = this.form.get('establishmentType')?.value;
      if (currentType) {
        this.updateValidatorsByEstablishmentType(currentType);
      }
    });
  }

  fileSelected(file: FileInput) {
    try {
      if (!file || !file.files || file.files.length === 0) {
        return;
      }

      const f = file.files[0];
      const name = f?.name || '';
      if (!name) return;

      // Split filename on '_', check for tokens
      const tokens = name.split('_').map(t => t.trim());

      // Match tokens case-insensitively
      const hasSf = tokens.some(t => /^sf$/i.test(t));
      const hasC = tokens.some(t => /^c$/i.test(t));

      let targetLabel: string | null = null;
      if (hasSf) {
        targetLabel = establishmentTypeFrenchTranslation(EstablishmentTypeEnum.SUPPORT_FUNCTION);
      } else if (hasC) {
        targetLabel = establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE);
      }

      if (targetLabel) {
        const ctrl = this.formEstablishmentType?.get('establishmentType');
        if (ctrl && ctrl.value !== targetLabel) {
          ctrl.setValue(targetLabel);
        }
      }
    } catch (e) {
      // No-op: keep UX silent on filename parsing issues
    }
  }

  toggleCompanyFields(isFrenchCompany: boolean) {
    const siretControl = this.form.get('siretNumber');
    const sirenControl = this.form.get('sirenNumber');
    const dunsControl = this.form.get('dunsNumber');
    const tvaControl = this.form.get('tva');
    const apeControl = this.form.get('ape');
    const vatStatusControl = this.form.get('vatStatus');
    const currentType = this.form.get('establishmentType')?.value;
    const isSupport = currentType === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.SUPPORT_FUNCTION);
    const isCare = currentType === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE);
    const linkedToMain = !!this.form.get('linkedToMain')?.value;

    if (isSupport) {
      if (isFrenchCompany) {
        dunsControl?.setValue('');
        dunsControl?.clearValidators();
        dunsControl?.updateValueAndValidity();

        if (!linkedToMain) {
          siretControl?.setValidators([Validators.required, Validators.pattern(/^[0-9]{14}$/)]);
          sirenControl?.setValidators([Validators.required, Validators.pattern(/^[0-9]{9}$/)]);
        } else {
          siretControl?.clearValidators();
          sirenControl?.clearValidators();
        }
        siretControl?.updateValueAndValidity();
        sirenControl?.updateValueAndValidity();
      } else {
        // En modification, ne pas effacer le SIRET/SIREN pour éviter de le perdre
        if (!this.isUpdateMode()) {
          siretControl?.setValue(null);
          sirenControl?.setValue(null);
        }
        siretControl?.clearValidators();
        sirenControl?.clearValidators();
        siretControl?.updateValueAndValidity();
        sirenControl?.updateValueAndValidity();

        dunsControl?.setValidators([Validators.required]);
        dunsControl?.updateValueAndValidity();

        // Pour établissements étrangers SUPPORT : TVA/APE/vatStatus non obligatoires
        tvaControl?.clearValidators();
        apeControl?.clearValidators();
        vatStatusControl?.clearValidators();
        tvaControl?.updateValueAndValidity();
        apeControl?.updateValueAndValidity();
        vatStatusControl?.updateValueAndValidity();
      }
      return;
    }

    if (isFrenchCompany) {
      // Entreprise française : vider DUNS, appliquer validateurs SIRET/SIREN
      dunsControl?.setValue(null);
      dunsControl?.clearValidators();
      dunsControl?.updateValueAndValidity();

      // Rendre SIRET et SIREN obligatoires (SIREN auto-complété)
      if (!this.form.get('linkedToMain')?.value) {
        siretControl?.setValidators([Validators.required, Validators.pattern(/^[0-9]{14}$/)]);
        sirenControl?.setValidators([Validators.required, Validators.pattern(/^[0-9]{9}$/)]);
        siretControl?.updateValueAndValidity();
        sirenControl?.updateValueAndValidity();
      }

      // Pour établissements français CARE : APE/vatStatus obligatoires, TVA optionnel
      if (isCare) {
        tvaControl?.clearValidators();
        apeControl?.setValidators([Validators.required]);
        vatStatusControl?.setValidators([Validators.required]);
        tvaControl?.updateValueAndValidity();
        apeControl?.updateValueAndValidity();
        vatStatusControl?.updateValueAndValidity();
      }
    } else {
      // Entreprise non française : vider SIRET/SIREN, rendre DUNS obligatoire
      siretControl?.setValue(null);
      sirenControl?.setValue(null);
      siretControl?.clearValidators();
      sirenControl?.clearValidators();
      siretControl?.updateValueAndValidity();
      sirenControl?.updateValueAndValidity();

      // Rendre DUNS obligatoire
      dunsControl?.setValidators([Validators.required]);
      dunsControl?.updateValueAndValidity();

      // Pour établissements étrangers : TVA/APE/vatStatus non obligatoires
      if (!this.isUpdateMode()) {
        tvaControl?.setValue(null);
        apeControl?.setValue(null);
        vatStatusControl?.setValue(null);
      }
      tvaControl?.clearValidators();
      apeControl?.clearValidators();
      vatStatusControl?.clearValidators();
      tvaControl?.updateValueAndValidity();
      apeControl?.updateValueAndValidity();
      vatStatusControl?.updateValueAndValidity();
    }

    // Garantir que les champs fiscaux restent désactivés si lié à un établissement principal
    if (linkedToMain) {
      tvaControl?.disable();
      apeControl?.disable();
      vatStatusControl?.disable();
    }
  }

  initForm() {
    this.form = new UntypedFormGroup({
      _id: new UntypedFormControl(this.defaults?._id),
      label: new UntypedFormControl(this.defaults?.label),
      sirenNumber: new UntypedFormControl(this.defaults?.sirenNumber),
      phoneNumber: this.phoneForm,
      siretNumber: new UntypedFormControl({
        value: this.defaults?.siretNumber,
        disabled: !!this.defaults?.mainEstablishmentId,
      }),
      dunsNumber: new UntypedFormControl(this.defaults?.dunsNumber),
      tva: new UntypedFormControl(this.defaults?.tva),
      ape: new UntypedFormControl(this.defaults?.ape),
      vatStatus: new UntypedFormControl(this.defaults?.vatStatus),
      attachedAccountant: new UntypedFormControl(this.defaults?.attachedAccountant),
      accountChart: new UntypedFormControl(this.defaults?.accountChart, [Validators.required]),
      establishmentType: new UntypedFormControl(
        establishmentTypeFrenchTranslation(this.defaults?.establishmentType) ||
          establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE),
        [Validators.required],
      ),
      billingAddress: new UntypedFormControl(this.defaults?.billingAddressData || this.defaults?.billingAddress),
      billingEmail: new UntypedFormControl(this.defaults?.billingEmail || '', [Validators.email]),
      paymentMethod: new UntypedFormControl(this.defaults?.paymentMethod || null),
      paymentMethodIban: new UntypedFormControl(this.defaults?.paymentMethod?.iban || ''),
      paymentMethodBic: new UntypedFormControl(this.defaults?.paymentMethod?.bic || ''),
      linkedToMain: this.linkedToMain,
      mainEstablishment: new UntypedFormControl(
        this.defaults?.mainEstablishmentData || this.defaults?.mainEstablishment,
      ),
      isFrenchCompany: new UntypedFormControl(true),
      accountingSoftwareId: new UntypedFormControl(this.defaults?.accountingSoftwareId),
    });

    // Initialiser le mode de facturation
    if (this.defaults?.billingEmail) {
      this.billingModeControl.setValue('email');
    } else {
      this.billingModeControl.setValue('address');
    }

    this.linkedToMain.setValue(!!this.defaults?.mainEstablishmentId);

    if (this.defaults?.attachedAccountant) {
      this.defaults.attachedAccountant.fullName = `${this.defaults.attachedAccountant.firstName} ${this.defaults.attachedAccountant.lastName}`;
    }

    if (this.isUpdateMode()) {
      this.form.controls.vatStatus.setValue(this.defaults?.vatStatus ? this.statusTva[0] : this.statusTva[1]);
    }

    if (this.isCreateMode()) {
      this.form.get('establishmentType')?.setValue(establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE));
    }

    if (this.isImportMode()) {
      this.formEstablishmentType = new UntypedFormGroup({
        establishmentType: new UntypedFormControl(this.establishmentType[0]),
      });
      this.formEstablishmentType.get('establishmentType').valueChanges.subscribe((value: any) => {
        this.establishmentTypeSelected = establishmentTypeFrenchToEnum(value);
      });
    }
  }

  updateValidatorsByEstablishmentType(type: string) {
    // SIRET/SIREN doivent être gérés par la case "Société française" et non par le type
    const requiredCARE = ['label', 'vatStatus', 'ape', 'attachedAccountant'];
    const requiredSUPPORT = ['label', 'attachedAccountant'];
    const allFieldForm = ['label', 'sirenNumber', 'siretNumber', 'tva', 'vatStatus', 'ape', 'attachedAccountant'];
    const isFrenchCompany = this.form.get('isFrenchCompany')?.value;

    allFieldForm.forEach(field => {
      const control = this.form.get(field);
      if (!control) {
        return;
      }

      // Pour les champs TVA/APE/vatStatus, ne les rendre obligatoires que si l'entreprise est française
      const fiscalFields = ['tva', 'vatStatus', 'ape'];
      let isRequired =
        (type === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE) && requiredCARE.includes(field)) ||
        (type === establishmentTypeFrenchTranslation(EstablishmentTypeEnum.SUPPORT_FUNCTION) &&
          requiredSUPPORT.includes(field));

      // Si le champ est fiscal ET que l'entreprise n'est pas française, ne pas le rendre obligatoire
      if (fiscalFields.includes(field) && !isFrenchCompany) {
        isRequired = false;
      }

      control.setValidators(isRequired ? [Validators.required] : []);
      control.updateValueAndValidity();
    });
  }

  // Force sending nulls and exclusivity between SIRET and DUNS
  private normalizeExclusiveCompanyIds(): void {
    const siret = (this.defaults as any)?.siretNumber;
    const duns = (this.defaults as any)?.dunsNumber;

    const hasSiret = typeof siret === 'string' ? siret.trim().length > 0 : !!siret;
    const hasDuns = typeof duns === 'string' ? duns.trim().length > 0 : !!duns;

    if (hasSiret) {
      // If SIRET provided, enforce DUNS = null
      (this.defaults as any).dunsNumber = null;
    } else if (hasDuns) {
      // If DUNS provided, enforce SIRET = null
      (this.defaults as any).siretNumber = null;
    } else {
      // If none provided, normalize both empty strings to null
      if (siret === '') {
        (this.defaults as any).siretNumber = null;
      }
      if (duns === '') {
        (this.defaults as any).dunsNumber = null;
      }
    }
  }

  // Ne conserver que le snapshot relation { _id, label, application } du plan sélectionné
  private buildAccountChartPayload(): any {
    const chart = this.form.controls.accountChart?.value;
    if (!chart?._id) {
      return null;
    }
    return { _id: chart._id, label: chart.label, application: chart.application };
  }

  beforeCreateItem() {
    this.defaults.establishmentType = this.convertFrenchLabelToEnum(this.form.controls.establishmentType.value);
    this.defaults.accountChart = this.buildAccountChartPayload();
    this.defaults.phoneNumber = this.phoneForm.getRawValue();
    this.defaults.vatStatus = this.form.controls.vatStatus.value === this.statusTva[0];
    this.defaults.mainEstablishmentId = this.form.controls.linkedToMain.value
      ? this.form.controls.mainEstablishment.value?._id
      : null;

    // Facturation : exclusif email ou adresse
    if (this.billingModeControl.value === 'email') {
      this.defaults.billingEmail = this.form.controls.billingEmail.value || null;
      this.defaults.billingAddressId = null;
    } else {
      this.defaults.billingAddressId = this.form.controls.billingAddress.value?._id || null;
      this.defaults.billingEmail = null;
    }

    // Mode de règlement avec IBAN/BIC embarqués
    this.defaults.paymentMethod = this.buildPaymentMethodPayload();

    // Ensure SIRET/DUNS exclusivity and nulls in payload
    this.normalizeExclusiveCompanyIds();
  }

  afterCreateItem(result?: any, error?: any) {
    if (result) {
      const label = result?.data?.label || this.form.get('label')?.value;
      const typeEnum =
        result?.data?.establishmentType || this.convertFrenchLabelToEnum(this.form.get('establishmentType')?.value);
      const typeLabel = establishmentTypeFrenchTranslation(typeEnum);
      this.snackbar.success(`Vous avez créé un établissement de type ${typeLabel}, libellé ${label}`);
      this.close(true);
      console.log('result', result);
      if (result?.data?._id) {
        this.router.navigate(['management/establishment', result?.data?._id]);
      }
    }
    if (error) {
      this.goToInfoStep();
      this.showBackendError(error, "Une erreur est survenue lors de la création de l'établissement.");
    }
  }

  /**
   * Affiche l'erreur backend la plus parlante : erreur de champ (errors[0].message) en priorité,
   * sinon le message backend s'il est affichable, sinon le message de repli
   */
  private showBackendError(error: any, fallbackMessage: string) {
    const fieldError = error?.error?.errors?.[0]?.message;
    const backendMessage = error?.error?.message;
    const isDisplayableMessage =
      typeof backendMessage === 'string' &&
      !!backendMessage &&
      !backendMessage.startsWith('http.') &&
      backendMessage !== 'Unprocessable Entity';
    this.snackbar.danger(fieldError || (isDisplayableMessage ? backendMessage : fallbackMessage));
  }

  beforeUpdateItem() {
    // Ne garder QUE les champs autorisés par EstablishmentUpdateDto
    // Évite d'envoyer les produits/prestations génériques enrichis (trop volumineux)
    const updatePayload: any = {
      _id: this.defaults._id, // OBLIGATOIRE pour BaseService.update() qui construit l'URL avec entity['_id']
      label: this.form.controls.label.value,
      tva: this.form.controls.tva.value || null,
      ape: this.form.controls.ape.value || null,
      vatStatus: this.form.controls.vatStatus.value === this.statusTva[0],
      phoneNumber: this.phoneForm.getRawValue(),
      establishmentType: this.convertFrenchLabelToEnum(this.form.controls.establishmentType.value),
      attachedAccountant: this.form.controls.attachedAccountant.value || null,
      accountChart: this.buildAccountChartPayload(),
      mainEstablishmentId: this.form.controls.linkedToMain.value
        ? this.form.controls.mainEstablishment.value?._id
        : null,
      paymentMethod: this.buildPaymentMethodPayload(),
      accountingSoftwareId: this.form.controls.accountingSoftwareId.value || null,
    };

    // Facturation : exclusif email ou adresse
    if (this.billingModeControl.value === 'email') {
      updatePayload.billingEmail = this.form.controls.billingEmail.value || null;
      updatePayload.billingAddressId = null;
    } else {
      updatePayload.billingAddressId = this.form.controls.billingAddress.value?._id || null;
      updatePayload.billingEmail = null;
    }

    // PRED-3187 : le SIRET est modifiable après création, le SIREN est dérivé (9 premiers chiffres)
    // Pour un établissement lié à un principal, le backend écrase avec les valeurs du parent
    const siretValue = this.form.get('siretNumber')?.value;
    if (siretValue) {
      updatePayload.siretNumber = siretValue.toString();
      updatePayload.sirenNumber = siretValue.toString().substring(0, 9);
    }
    // Le DUNS reste géré uniquement à la création

    this.defaults = updatePayload;

    // Note: normalizeExclusiveCompanyIds() n'est plus nécessaire car on ne modifie pas ces champs
  }

  private buildPaymentMethodPayload(): any {
    const pm = this.form.controls.paymentMethod.value;
    if (!pm) {
      return null;
    }
    const payload: any = {
      _id: pm._id,
      label: pm.label,
      requiresBankDetails: pm.requiresBankDetails ?? false,
    };
    if (pm.requiresBankDetails) {
      payload.iban = this.form.controls.paymentMethodIban.value || null;
      payload.bic = this.form.controls.paymentMethodBic.value || null;
    }
    return payload;
  }

  afterUpdateItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
    }
    if (error) {
      this.goToInfoStep();
      this.showBackendError(error, "Une erreur est survenue lors de la modification de l'établissement.");
    }
  }

  afterImportItem(result?: any) {
    if (result) {
      this.close(true);
    }
  }

  accountChartAutocompleteChange(state = '') {
    this.accountCharts$ = this.accountChartService
      .findAll(null, 'all', 'label', 'asc', state, null)
      .pipe(map(x => x.data));
  }

  customerReferentAutocompleteChange(state = '') {
    this.userProfiles$ = this.userProfileService
      .findAll(null, null, 'fullName', 'asc', state, {
        isAccountant: true,
        isPredik: false,
      })
      .pipe(map(x => x.data));
  }

  addressAutocompleteChange(state = '') {
    // Utiliser findAll avec le paramètre search pour tous les cas
    this.addresses$ = this.addressService
      .findAll(1, state?.trim() ? 50 : 100, 'street', 'asc', state?.trim() || '', {
        isActive: true,
        requiredFields: [
          '_id',
          'label',
          'street',
          'additionalAddress',
          'city',
          'postalCode',
          'country',
          'buildingsInfo',
        ],
      })
      .pipe(map(x => x.data));
  }

  // Chargement et gestion du tableau des adresses de facturation
  loadAddresses(page = 1) {
    // Assure le chargement des infos de bâtiments pour l'affichage en table
    this.addressService
      .findAll(page, this.addressPageSize, this.addressSortField, this.addressSortOrder, this.addressSearch, {
        requiredFields: [
          '_id',
          'label',
          'street',
          'additionalAddress',
          'city',
          'postalCode',
          'country',
          'buildingsInfo',
        ],
      })
      .subscribe(res => {
        this.addressesDataSource.data = res.data;
        this.addressCount = res.totalData;
      });
  }

  onAddressPage(event: PageEvent) {
    this.addressPageSize = event.pageSize;
    this.addressPageIndex = event.pageIndex + 1;
    this.loadAddresses(this.addressPageIndex);
  }

  onAddressSort(event: Sort) {
    this.addressSortField = event.active;
    this.addressSortOrder = event.direction as any;
    this.loadAddresses(this.addressPageIndex);
  }

  onAddressSearch(value: string) {
    this.addressSearch = value;
    this.addressPageIndex = 1;
    this.loadAddresses();
  }

  selectBillingAddress(address: AddressModel) {
    this.form.get('billingAddress')?.setValue(address);
  }

  goToBillingStep() {
    // Forcer la validation du formulaire
    this.form.markAllAsTouched();

    // Vérifier que le formulaire n'est pas en cours de validation asynchrone
    if (this.form.status === 'PENDING') {
      // Attendre que la validation asynchrone se termine
      const subscription = this.form.statusChanges.subscribe(status => {
        if (status !== 'PENDING') {
          subscription.unsubscribe();
          this.proceedToBillingStep();
        }
      });
      return;
    }

    this.proceedToBillingStep();
  }

  private proceedToBillingStep() {
    // Forcer la mise à jour de la validité du groupe d'étape "Informations"
    this.infoStepGroup.updateValueAndValidity();

    // Marquer tous les champs comme touchés pour afficher les erreurs de validation
    this.form.markAllAsTouched();

    // Vérifier que l'étape "Informations" est valide avant de permettre la navigation
    if (this.infoStepGroup.invalid) {
      return;
    }

    this.stepper.next();
    this.billingStepGroup.updateValueAndValidity();
  }

  goToInfoStep() {
    // Retour absolu au step Informations : la soumission peut partir du step 2 ou 3,
    // un stepper.previous() relatif laisserait l'utilisateur sur le mauvais step
    if (this.stepper && this.stepper.selectedIndex !== 0) {
      this.stepper.selectedIndex = 0;
    }
    this.loading = false;
    setTimeout(() => (this.loading = false), 0);
  }

  goToPaymentStep() {
    this.form.markAllAsTouched();
    this.billingStepGroup?.updateValueAndValidity();

    if (this.billingStepGroup?.invalid) {
      return;
    }

    this.stepper.next();
    this.paymentStepGroup?.updateValueAndValidity();
  }

  goBackFromPaymentStep() {
    this.stepper.previous();
    this.loading = false;
    setTimeout(() => (this.loading = false), 0);
  }

  loadMainEstablishment(id: string) {
    const sirenControl = this.form.get('sirenNumber');
    const siretControl = this.form.get('siretNumber');
    const tvaControl = this.form.get('tva');
    const apeControl = this.form.get('ape');
    const vatStatusControl = this.form.get('vatStatus');

    // Reset current values before fetching
    sirenControl?.reset();
    siretControl?.reset();
    tvaControl?.reset();
    apeControl?.reset();
    vatStatusControl?.reset();

    this.service.findById(id).subscribe(res => {
      const data = res.data as EstablishmentModel;
      if (data.siretNumber) {
        siretControl?.setValue(data.siretNumber);
      }
      if (data.sirenNumber) {
        sirenControl?.setValue(data.sirenNumber);
      }
      if (data.tva) {
        tvaControl?.setValue(data.tva);
      }
      if (data.ape) {
        apeControl?.setValue(data.ape);
      }
      if (data.vatStatus !== undefined) {
        const vatStatusValue = data.vatStatus ? this.statusTva[0] : this.statusTva[1];
        vatStatusControl?.setValue(vatStatusValue);
      }
    });
  }

  establishmentAutocompleteChange(state = '') {
    this.establishments$ = this.service
      .findAllAsSelect(true, 'label', 'asc', state, { establishmentType: EstablishmentTypeEnum.CARE })
      .pipe(map(x => x.data));
  }

  convertFrenchLabelToEnum(frenchLabel: string): EstablishmentTypeEnum {
    switch (frenchLabel) {
      case establishmentTypeFrenchTranslation(EstablishmentTypeEnum.CARE):
        return EstablishmentTypeEnum.CARE;
      case establishmentTypeFrenchTranslation(EstablishmentTypeEnum.SUPPORT_FUNCTION):
        return EstablishmentTypeEnum.SUPPORT_FUNCTION;
      default:
        throw new Error('Unknown establishment type: ' + frenchLabel);
    }
  }

  downloadEstablishmentTemplate() {
    // Deprecated: kept for compatibility
    this.service.downloadExcelEstablishmentsTemplate().subscribe((x: any) => {
      const b = b64ToBlob(x.data.b64, ContentTypeEnum.excel);
      this.fileSaver.save(b, x.data.fileName);
    });
  }

  // Nouveau: téléchargement du modèle combiné
  downloadEstablishmentsTemplateCombined() {
    this.service.downloadExcelEstablishmentsTemplate().subscribe((x: any) => {
      const b = b64ToBlob(x.data.b64, ContentTypeEnum.excel);
      this.fileSaver.save(b, x.data.fileName);
    });
  }

  // Anciennes variantes par type supprimées (modèle unifié désormais)

  importItems() {
    // Deprecated: use importItemsCombined
    this.importItemsCombined();
  }

  importItemsCombined() {
    this.importDefaults = this.importForm.value;
    this.beforeImportItem();

    if (this.importForm.valid) {
      this.loading = true;
      const sub = this.service.importEstablishments(this.importDefaults).subscribe(
        result => {
          this.afterImportItem(result);
          this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Import, result.message ?? 'Import effectué');
        },
        error => {
          this.afterImportItem(null);
          this.setImportErrorsMessages(error.error.errors);
          this.loading = false;
        },
      );
      this.subscription.add(sub);
    } else {
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  // Anciennes variantes d'import par type supprimées (import combiné désormais)

  // Override update to use step validators instead of this.form.valid
  // (requireMatchHelper on autocomplete controls can make the form invalid even when steps are valid)
  override updateItem(): void {
    this.loading = true;

    const infoValid = this.infoStepGroup?.valid;
    const billingValid = this.billingStepGroup?.valid;
    const paymentValid = this.paymentStepGroup?.valid;

    if (!infoValid || !billingValid || !paymentValid) {
      this.onFormInvalid();
      this.loading = false;
      return;
    }

    this.defaults = this.form.getRawValue();
    this.beforeUpdateItem();

    const sub = this.service.update(this.defaults).subscribe(
      result => {
        this.afterUpdateItem(result, null);
        this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Update, result.message);
      },
      error => {
        this.afterUpdateItem(null, error);
        this.setErrorsMessages(error.error?.errors);
        this.loading = false;
      },
    );
    this.subscription.add(sub);
  }

  // Override create to control payload and step validations locally
  override createItem(): void {
    this.loading = true;

    // Validate all steps
    const infoValid = this.infoStepGroup?.valid;
    const billingValid = this.billingStepGroup?.valid;
    const paymentValid = this.paymentStepGroup?.valid;

    if (!infoValid || !billingValid || !paymentValid) {
      this.onFormInvalid();
      this.loading = false;
      return;
    }

    // Read raw values (includes disabled controls like billingAddress before enabling)
    this.defaults = this.form.getRawValue();

    // Prepare defaults via existing hook (sets enums, phone, vat, address ids, linkage, exclusivity)
    this.beforeCreateItem();

    // Submit
    const sub = this.service.create(this.defaults).subscribe(
      result => {
        this.afterCreateItem(result, null);
        this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Create, result.message);
      },
      error => {
        this.afterCreateItem(null, error);
        console.log('error', error);
        this.setErrorsMessages(error.error?.errors);
        this.loading = false;
      },
    );
    this.subscription.add(sub);
  }
}
